import React, { useEffect } from 'react';
import { post } from '../../api';

import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { addData, addOdooData, ContactRole, setPermissions } from '../user/userSlice';
import { useDispatch } from 'react-redux';
import { AutoLogin, setLoginState } from './loginSlice';

const AutoLoginContainer = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentLocation = useLocation();

  const PREVENT_AUTO_LOGIN = ['/invite/accept', '/user-invite/accept', '/resetpassword', '/setnewpassword', '/terms-and-conditions', '/privacy-policy'];

  const autoLogin = async () => {

    let prevent = false;
    PREVENT_AUTO_LOGIN.map(x => {

      if (currentLocation.pathname.indexOf(x) > -1) {
        prevent = true;
      }
    });

    if (prevent) {
      return;
    }

    const response = await post('autoauth');
    
    dispatch(setLoginState(AutoLogin.DONE));

    if (response.status === 200) {

      dispatch(addData(response.data.data));
      dispatch(setPermissions(response.data.permissions));

      if (currentLocation.pathname === '/' && response.data?.data?.role === ContactRole.ADMIN) {
        navigate('/manage-devices');
      } else if (currentLocation.pathname === '/') {
        navigate('/clients');
      }
      
    } else {
      navigate('/');
    }
  };

  useEffect(()=>{

    autoLogin();
  },[]);

  return null;
};

export default AutoLoginContainer;